import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Ban, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminBuyers() {
  const [buyers, setBuyers] = useState([]);

  const load = () => api.get("/admin/buyers").then((r) => setBuyers(r.data.buyers)).catch(() => toast.error("Failed to load buyers"));
  useEffect(() => { load(); }, []);

  const toggleActive = async (b) => {
    try {
      await api.post(`/users/${b.id}/${b.active === false ? "activate" : "deactivate"}`);
      toast.success(b.active === false ? "Buyer activated" : "Buyer deactivated");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div data-testid="admin-buyers-page" className="space-y-4">
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight">Buyer Management</h1>
        <p className="text-sm text-muted-foreground">Workload and pending actions per buyer.</p>
      </div>
      <div className="overflow-x-auto rounded-lg border bg-card">
        <table className="w-full text-sm" data-testid="buyers-table">
          <thead>
            <tr className="border-b text-left text-xs uppercase tracking-wide text-muted-foreground">
              <th className="px-5 py-3 font-medium">Buyer</th>
              <th className="px-5 py-3 font-medium">Email</th>
              <th className="px-5 py-3 font-medium">Department</th>
              <th className="px-5 py-3 font-medium text-right">Active POs</th>
              <th className="px-5 py-3 font-medium text-right">Pending Actions</th>
              <th className="px-5 py-3 font-medium">Status</th>
              <th className="px-5 py-3 font-medium text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {buyers.map((b) => (
              <tr key={b.id} data-testid={`buyer-row-${b.email}`} className="border-b last:border-0 hover:bg-slate-50">
                <td className="px-5 py-3 font-medium">{b.name}</td>
                <td className="px-5 py-3 font-mono text-xs">{b.email}</td>
                <td className="px-5 py-3 text-muted-foreground">{b.department || "—"}</td>
                <td className="px-5 py-3 text-right font-mono">{b.active_pos}</td>
                <td className={`px-5 py-3 text-right font-mono ${b.pending_actions > 0 ? "font-semibold text-[#D97706]" : ""}`}>{b.pending_actions}</td>
                <td className="px-5 py-3">
                  <span className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${b.active === false ? "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]" : "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]"}`}>
                    {b.active === false ? "INACTIVE" : "ACTIVE"}
                  </span>
                </td>
                <td className="px-5 py-3 text-right">
                  <Button size="sm" variant="ghost" data-testid={`buyer-toggle-${b.email}`} onClick={() => toggleActive(b)} className={b.active === false ? "text-green-600" : "text-red-500"}>
                    {b.active === false ? <><CheckCircle2 className="mr-1 h-4 w-4" /> Activate</> : <><Ban className="mr-1 h-4 w-4" /> Deactivate</>}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
